"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.TagIcon = function (_a) {
    var icon = _a.icon, color = _a.color;
    return (react_1.default.createElement(StyledIcon, { className: "icon--" + icon, color: color }));
};
exports.TagIcon.displayName = 'FOS_TagIcon';
var StyledIcon = styled_components_1.default.i(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  align-items: center;\n  color: ", ";\n  margin-right: 0.8rem;\n  font-size: 1.4rem;\n  display: block;\n  margin-bottom: auto;\n  margin-top: 0.2rem;\n"], ["\n  align-items: center;\n  color: ", ";\n  margin-right: 0.8rem;\n  font-size: 1.4rem;\n  display: block;\n  margin-bottom: auto;\n  margin-top: 0.2rem;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var templateObject_1;
